const LANGUAGE_MAP = {
  hr: 'hr-HR',
  de: 'de-DE',
  it: 'it-IT',
  sl: 'sl-SI',
  nl: 'nl-NL',
  pl: 'pl-PL'
}

const WEBSITE_KEY = 'cbc5ca3f-e64e-443f-a29d-56db1b5267bc'
const SCRIPT_ID = 'cookietractor-script'

function loadCookieTractor(lang) {
  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = 'https://cdn.cookietractor.com/cookietractor.js'
  script.setAttribute('data-lang', LANGUAGE_MAP[lang] || 'en-150')
  script.setAttribute('data-id', WEBSITE_KEY)
  document.head.appendChild(script)
}

export default defineNuxtPlugin(() => {
  const { lang } = useLanguage()

  loadCookieTractor(lang.value)
})
